(function () {
  function clean(t) {
    return (t || "").replace(/\s+/g, " ").trim();
  }

  function getDrawer() {
    return document.querySelector("#facets-drawer");
  }

  function isDrawerOpen(drawer) {
    if (!drawer) return false;
    return drawer.hasAttribute("open") || drawer.classList.contains("is-open") || drawer.matches(":popover-open");
  }

  function getInsertPoint(drawer) {
    // ✅ inserir SEMPRE depois do header (para não tapar o X)
    const header =
      drawer.querySelector("header") ||
      drawer.querySelector(".drawer__header") ||
      drawer.querySelector(".facets-drawer__header");

    if (header) return header;

    // fallback: primeiro elemento dentro do drawer
    return drawer.firstElementChild || drawer;
  }

  function ensureBox(drawer) {
    let box = drawer.querySelector(".rh-applied-filters");
    if (box) return box;

    box = document.createElement("div");
    box.className = "rh-applied-filters";
    box.innerHTML = `
      <div class="rh-applied-title">Applied filters</div>
      <div class="rh-applied-body"></div>
    `;

    const insertAfter = getInsertPoint(drawer);
    insertAfter.insertAdjacentElement("afterend", box);

    return box;
  }

  function parseFiltersFromURL() {
    const url = new URL(window.location.href);
    const items = [];
    for (const [key, value] of url.searchParams.entries()) {
      if (!key.startsWith("filter.")) continue;
      if (!value) continue;
      items.push({ key, value });
    }
    return items;
  }

  function makeRemoveURL(key, value) {
    const url = new URL(window.location.href);
    const entries = Array.from(url.searchParams.entries());

    url.search = "";
    const rebuilt = new URLSearchParams();
    let removedOnce = false;

    for (const [k, v] of entries) {
      if (!removedOnce && k === key && v === value) {
        removedOnce = true;
        continue;
      }
      rebuilt.append(k, v);
    }

    url.search = rebuilt.toString();
    return url.toString();
  }

  // 🔥 NOVO: tenta converter o "value" do URL (ex: aa-1-13-13) no label humano do filtro (ex: Hoodies)
  function findLabelForFilter(key, value) {
    try {
      const sel = [
        `#facets-drawer input[name="${CSS.escape(key)}"][value="${CSS.escape(value)}"]`,
        `input[name="${CSS.escape(key)}"][value="${CSS.escape(value)}"]`,
      ].join(",");

      const input = document.querySelector(sel);
      if (!input) return "";

      // 1) se existir data-label (se adicionares via liquid no futuro)
      const dl = input.dataset && (input.dataset.label || input.getAttribute("data-label"));
      if (dl) return clean(dl);

      // 2) label associado por "for"
      if (input.id) {
        const lbl = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (lbl) return clean(lbl.textContent);
      }

      // 3) wrapper <label> ... <input> ... texto
      const parentLabel = input.closest("label");
      if (parentLabel) return clean(parentLabel.textContent);

      // 4) fallback: aria-label
      const aria = input.getAttribute("aria-label");
      if (aria) return clean(aria);

      return "";
    } catch (e) {
      // se CSS.escape falhar por algum motivo, faz fallback para value
      return "";
    }
  }

  function render() {
    const drawer = getDrawer();
    if (!drawer) return;
    if (!isDrawerOpen(drawer)) return;

    const box = ensureBox(drawer);
    const body = box.querySelector(".rh-applied-body");
    if (!body) return;

    const filters = parseFiltersFromURL();
    body.innerHTML = "";

    if (!filters.length) {
      box.style.display = "none";
      return;
    }

    box.style.display = "";

    filters.forEach(({ key, value }) => {
      const a = document.createElement("a");
      a.className = "rh-chip";
      a.href = makeRemoveURL(key, value);
      a.setAttribute("role", "button");
      a.innerHTML = `<span class="rh-chip-x" aria-hidden="true">×</span><span class="rh-chip-txt"></span>`;

      // ✅ usa label humano quando existir, senão usa o value do URL
      const labelRaw = findLabelForFilter(key, value) || clean(value);
      // opcional: remover contagens " (12)" se existirem no label
      const label = labelRaw.replace(/\s*\(\d+\)\s*$/, "");

      a.querySelector(".rh-chip-txt").textContent = label;
      body.appendChild(a);
    });
  }

  // ✅ sem MutationObserver agressivo
  document.addEventListener("DOMContentLoaded", render);
  window.addEventListener("load", render);
  window.addEventListener("popstate", render);

  // quando abres a gaveta
  document.addEventListener("click", (e) => {
    const btn = e.target.closest('button[aria-controls="facets-drawer"], a[aria-controls="facets-drawer"]');
    if (!btn) return;
    setTimeout(render, 50);
    setTimeout(render, 200);
  });
})();